import React, { useMemo } from "react";

interface YTPlayerProps {
  videoUrl: string;
}

const getYoutubeEmbedUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace("www.", "");

    let videoId = "";

    if (hostname === "youtu.be") {
      videoId = parsedUrl.pathname.slice(1);
    } else if (
      hostname === "youtube.com" ||
      hostname === "m.youtube.com" ||
      hostname === "music.youtube.com"
    ) {
      if (parsedUrl.pathname === "/watch") {
        videoId = parsedUrl.searchParams.get("v") ?? "";
      } else if (parsedUrl.pathname.startsWith("/embed/")) {
        videoId = parsedUrl.pathname.split("/embed/")[1] ?? "";
      } else if (parsedUrl.pathname.startsWith("/shorts/")) {
        videoId = parsedUrl.pathname.split("/shorts/")[1] ?? "";
      }
    }

    if (!videoId) {
      return url;
    }

    const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);

    if (parsedUrl.searchParams.get("autoplay") === "1") {
      embedUrl.searchParams.set("autoplay", "1");
    }

    return embedUrl.toString();
  } catch {
    return url;
  }
};

const YTPlayer: React.FC<YTPlayerProps> = ({ videoUrl }) => {
  const embedUrl = useMemo(() => getYoutubeEmbedUrl(videoUrl), [videoUrl]);

  return (
    <div className="w-full">
      <iframe
        src={embedUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="w-full aspect-video rounded-lg"
      />
    </div>
  );
};

export default YTPlayer;
